import { render, staticRenderFns } from "./FaceScan.vue?vue&type=template&id=38afff40&scoped=true&"
import script from "./FaceScan.vue?vue&type=script&lang=js&"
export * from "./FaceScan.vue?vue&type=script&lang=js&"
import style0 from "./FaceScan.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FaceScan.vue?vue&type=style&index=1&id=38afff40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38afff40",
  null
  
)

export default component.exports